/**
 * Notification types handled as campaign-admin navigation (permalink).
 */
export const CampaignAdminNotificationTypes = Object.freeze([
    'campaign_admin_tip',
    'dashboard',
    'marketing',
    'updates',
    'settings',
    'finances',
    'editor',
    'editor_privacy',
    'editor_story',
    'editor_optional',
    'editor_website_links',
    'editor_custom_sharing',
    'campaign',
]);
